import { EVENT_NAMES } from 'services/analytics/eventNames';
import { trackEvent } from 'services/analytics/trackEvent';

export const ImportCompaniesSuccessStates = {
  START: 'Start',
  SUCCESS: 'Success',
} as const;

export type ImportCompaniesSuccessStateType =
  (typeof ImportCompaniesSuccessStates)[keyof typeof ImportCompaniesSuccessStates];

type Props = {
  group_id: string;
  section_name: string;
  sub_section_name: string;
  click_text: string;
  success_state: ImportCompaniesSuccessStateType;
};

export const trackImportCompanies = ({
  group_id,
  section_name,
  sub_section_name,
  click_text,
  success_state,
}: Props) => {
  trackEvent(EVENT_NAMES.IMPORT_COMPANIES, {
    group_id,
    section_name,
    sub_section_name,
    click_text,
    success_state,
  });
};
